import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BlurRevealText from "./BlurRevealText";

// Order matches reliability.certifications in the locale files.
const certIconTypes = ["iso", "gdpr", "soc", "pci"];

function CertIcon({ type }) {
  const common = {
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };
  const stroke = "currentColor";

  if (type === "iso") {
    return (
      <svg {...common}>
        <circle cx="22" cy="22" r="20" stroke={stroke} strokeWidth="1.4" />
        <path
          d="M22 11.5 30 15v6.6c0 5-3.3 9.5-8 10.9-4.7-1.4-8-5.9-8-10.9V15l8-3.5z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="m18.5 21.8 2.6 2.6 4.6-5"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "gdpr") {
    return (
      <svg {...common}>
        <circle cx="22" cy="22" r="20" stroke={stroke} strokeWidth="1.4" />
        <rect
          x="15"
          y="20.5"
          width="14"
          height="11"
          rx="2.5"
          stroke={stroke}
          strokeWidth="1.5"
        />
        <path
          d="M18 20.5v-3.2a4 4 0 0 1 8 0v3.2"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M22 24.5v3"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "soc") {
    return (
      <svg {...common}>
        <circle cx="22" cy="22" r="20" stroke={stroke} strokeWidth="1.4" />
        <path
          d="M17 12h8l4 4v16H17z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M25 12v4h4" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
        <path
          d="m19.5 24.5 2 2 3.5-4"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  // pci
  return (
    <svg {...common}>
      <circle cx="22" cy="22" r="20" stroke={stroke} strokeWidth="1.4" />
      <rect
        x="12.5"
        y="15.5"
        width="19"
        height="13"
        rx="2.5"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path d="M12.5 20h19" stroke={stroke} strokeWidth="1.5" />
      <path
        d="M16 25h4"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ReliabilityArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10.4688 4.375L16.0938 10L10.4688 15.625M15.3125 10H3.90625"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ReliabilitySection() {
  const { t } = useTranslation();
  const stats = t("reliability.stats", { returnObjects: true });
  const certifications = t("reliability.certifications", { returnObjects: true });

  return (
    <section className="reliability-section">
      <div className="container">
        <div className="reliability-panel">
          <BlurRevealText
            as="h2"
            className="reliability-title"
            lines={[t("reliability.title")]}
          />
          <p className="reliability-subtitle">{t("reliability.subtitle")}</p>

          <div className="reliability-stats">
            {stats.map((item) => (
              <article className="reliability-stat" key={item.label}>
                <strong className="reliability-stat-value">{item.value}</strong>
                <span className="reliability-stat-label">{item.label}</span>
              </article>
            ))}
          </div>

          <div className="reliability-certs">
            {certifications.map((item, index) => (
              <div className="reliability-cert" key={item.name}>
                <span className="reliability-cert-icon">
                  <CertIcon type={certIconTypes[index]} />
                </span>
                <div>
                  <strong className="reliability-cert-name">{item.name}</strong>
                  <span className="reliability-cert-detail">{item.detail}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="reliability-actions">
            <Link className="reliability-link" to="/privacy">
              {t("reliability.trustCenter")}
              <ReliabilityArrowIcon />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReliabilitySection;
